import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserService } from '@wm-libs/core';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard {
  constructor(private userService: UserService, private router: Router, private location: Location) {}

  canLoad(): Observable<boolean> {
    const isInviteRoute = this.location.path().includes('auth/sign-up/confirm-invitation/');

    return this.userService.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        const canLoad = !isAuthenticated || (isAuthenticated && isInviteRoute);

        if (!canLoad) {
          this.router.navigate(['/']);
        }

        return canLoad;
      })
    );
  }
}
